export const COLORS = {
    SKY_BLUE: '#008fd6',
    WHITE: '#fff',
    TRANSPARENT: '#ffffff0a',
    BLACK: '#000',
    YELLOW_BG: '#e9d5a1',
    LIGHT_BG: 'rgb(255 246 223)',
    GREEN: '#00FF00',
    GREY: '#808080',
    ORANGE: '#FFA500',
    PRIMARY: '#007bff',
    SECONDARY: '#6c757d',
    SUCCESS: '#28a745',
    DANGER: '#dc3545',
    WARNING: '#ffc107',
    INFO: '#17a2b8',
    DARK: '#343a40',
    PROJECT_BG: '#3a3b3c',
}
